import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Target, LogOut } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <header className="sticky top-0 z-40 bg-black/60 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-home" className="flex items-center gap-2.5">
            <img src="/crest.png" alt="5N2 Footy Academy crest" className="w-8 h-8 object-contain" />
            <span className="font-display text-xl font-black uppercase tracking-tight">
              5N2 Academy
            </span>
          </Link>
          <div className="flex items-center gap-4">
            <span className="hidden sm:block text-xs font-bold uppercase tracking-[0.15em] text-[#71717A]">
              {user?.name || "Coach"}
            </span>
            <Button
              data-testid="logout-button"
              variant="ghost"
              onClick={() => {
                logout();
                navigate("/login");
              }}
              className="rounded-none text-[#A1A1AA] hover:text-white hover:bg-[#1A1A1A]"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
